import { render, staticRenderFns } from "./KnowledgeManagement.vue?vue&type=template&id=829488ec&scoped=true"
import script from "./KnowledgeManagement.vue?vue&type=script&lang=js"
export * from "./KnowledgeManagement.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeManagement.vue?vue&type=style&index=0&id=829488ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829488ec",
  null
  
)

export default component.exports